import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const shimmerKeyframes = `
  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
export const SkeletonLoader = () => (_jsxs(_Fragment, { children: [_jsx("style", { children: shimmerKeyframes }), _jsx("div", { style: {
                height: 180,
                borderRadius: 10,
                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite linear"
            } })] }));
